import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DatastoreService {
  public daySelected = new Subject<any>();
  filesStrings: any;
  schema: any;
  excludedChoicesServiceIds: any[] = [];

  constructor() { }

  setCalendarDay(date: any, slot: any): any {
    return slot.daySelected.next(date);
  }

  getCalendarDay(slot: any): Observable<any> {
    return slot.daySelected.asObservable();
  }

  getLatestMulti(): any {
    if (this.extraBookings.length === 0) {
      this.newMultiBooking()
    }
    return this.extraBookings[this.extraBookings.length - 1]
  }

  setColors(config:any){
    console.log("set col" , config) 
    console.log("set col" , config.button_colours) 
    if(config.button_colours){
      this.primary_btn_back_colour = config.button_colours.primary_btn_back_colour
      this.primary_btn_back_colour_hover = config.button_colours.primary_btn_back_colour_hover
      this.primary_btn_text_colour = config.button_colours.primary_btn_text_colour
      this.primary_btn_text_colour_hover = config.button_colours.primary_btn_text_colour_hover
      this.secondary_btn_back_colour = config.button_colours.secondary_btn_back_colour
      this.secondary_btn_back_colour_hover = config.button_colours.secondary_btn_back_colour_hover
      this.secondary_btn_text_colour = config.button_colours.secondary_btn_text_colour
      this.secondary_btn_text_colour_hover = config.button_colours.secondary_btn_text_colour_hover
    }
    console.log("color!!!",config.myCeremony.themeColor )
    document.documentElement.style.setProperty('--themeColor', config.myCeremony.themeColor);

  }

  newMultiBooking() {
    this.extraBookings.push({
      bookingDetails: {
        serviceId: "",
        childCompanyId: "",
        parentCompanyId: "",
        resourceId: "",
        resourceName: "",
        event_id: "",
        time: "",
        date: "",
        addon: "",
        attendees: [],
        bookingId:"",
        res: ""
      },
      daySelected: new Subject<any>(),
      bookingQuestions:[]
    })
  }

  public multi = false

  public config: any;

  /** Fallback used only if `register_office_email` is missing from the config. */
  static readonly DEFAULT_REGISTER_OFFICE_EMAIL = 'notifications@bookinglab.co.uk';

  /**
   * The configured register office recipient, or undefined when the config
   * does not set one. Callers that have their own signed-off default — see the
   * `defaultTo` entries in AlertNotificationService — need to tell "config says
   * X" apart from "config says nothing", which `registerOfficeEmail` collapses.
   */
  get registerOfficeEmailConfigured(): string | undefined {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.myCeremony?.register_office_email || undefined;
    } catch {
      return undefined;
    }
  }

  /**
   * Register office notification recipient, pulled from the company config
   * (`myCeremony.register_office_email`) so it can be changed without a
   * front-end deploy. Falls back to the Westminster default if the config is
   * unparseable or the key is absent. Read by ExtendStateService and the
   * ceremony-choices journey when notifying the office.
   */
  get registerOfficeEmail(): string {
    return (
      this.registerOfficeEmailConfigured ||
      DatastoreService.DEFAULT_REGISTER_OFFICE_EMAIL
    );
  }

  /** HTML body template for the extend enquiry admin email. */
  get extendEnquiryAdminEmailTemplate(): string {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.myCeremony?.extendCeremony?.extendEnquiryAdminEmailTemplate || '';
    } catch {
      return '';
    }
  }

  /** Subject line for the extend enquiry admin email. */
  get extendEnquiryAdminEmailSubject(): string {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.myCeremony?.extendCeremony?.extendEnquiryAdminEmailSubject || 'Extended ceremony enquiry';
    } catch {
      return 'Extended ceremony enquiry';
    }
  }

  /** HTML body template for the add-on customer email. */
  get addOnEmailTemplate(): string {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.myCeremony?.['optional-addons']?.addOnEmailTemplate || '';
    } catch {
      return '';
    }
  }

  /** Subject line for the add-on customer email. */
  get addOnEmailSubject(): string {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.myCeremony?.['optional-addons']?.addOnSubject || 'Your ceremony add-ons';
    } catch {
      return 'Your ceremony add-ons';
    }
  }

  static readonly DEFAULT_NOTIFICATIONS_FROM_EMAIL = 'notifications@bookinglab.co.uk';

  /** Master switch for the back-office alert emails. Fails closed. */
  get alertsEnabled(): boolean {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.alerts === true;
    } catch {
      return false;
    }
  }

  /** Sender for the back-office alert emails. */
  get notificationsFromEmail(): string {
    try {
      const parsed = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
      return parsed?.global_notifications?.from || DatastoreService.DEFAULT_NOTIFICATIONS_FROM_EMAIL;
    } catch {
      return DatastoreService.DEFAULT_NOTIFICATIONS_FROM_EMAIL;
    }
  }

  public companies: any;

  public childCompanies: any;

  public isDayService: any;

  public selectedDate: any;

  public services = [];

  public resources = [];

  public slots = [];

  public extraBookings: any = []; // added via sidebar

  public rootCompany: any;

  public selectedCompany: any;

  public selectedService: any;

  public selectedResource: any;

  public selectedSlot: any;

  public selectedResourceLabel: String = "";

  public bookingQuestions = [];

  public customerQuestions = [];

  public address: any;

  public lattitude: any;

  public longitude: any;

  public booking: any;

  /**
   * True when the booking's extra-item links include an extension item
   * ("Extended ceremony time (30/60 minutes)"). Computed by our-ceremony from
   * the booking's links; catches bookings extended before settings.extended_at
   * was stamped (RWRSPI-1010). Read alongside extended_at by alreadyExtended
   * and extendNotExtendedGuard.
   */
  public bookingHasExtensionItem = false;

  public purchase: any;

  public client: any;

  public loginObject: any;

  public loggedIn: boolean = false;

  public selectedServiceName: any;

  public member: any;

  public company: any;

  public childCompany: any;

  public authToken: any;

  public timeLimits: any;

  public basket: any;

  public basketEndTime: any;

  public serviceItem: any;

  public checkout: any = "";

  public answeredQuestions: any;

  public loggedInBySSO: boolean = false;

  public paidAmount: number = 0;

  public purchasedBookings: any = [];

  public isHAF: boolean = false;

  public hafSingleStepChildProcess: boolean = false;

  public childrenToRegister : any[] = [];

  public maxChildren: number = 3;

  public token: string = "";
  public password: string = "";

  public clientEmail: string = "";

  public workflowId: string = "";

  public loadedApplication: any = false;

  public pageChanged: Subject<string> = new Subject<string>();
  public currentPage: string = '';

  public customObjects: any = {};

  public messageThreads: any = [];
  public activeThread: any;
  public messagesOnActiveThread: any[];
  public rescheduleOptions: string[] = [];
  public selectedSuggestion: any = {};
  public selectedRescheduleService: any = null;
  public addOnOptions: string[] = [];
  public addOnQuantities: {
    confetti?: number;
    certificates?: number;
    /** item_id → quantity, for each selected "Drinks" extra. */
    drinks?: Record<string, number>;
  } = {};
  public selectedRescheduleSlot: any = null;
  public selectedRescheduleDate: Date | null = null;
  public rescheduleCompleted = false;
  public reschedulePriceDifference = 0;
  public reschedulePriceComparison: {
    item_id: string;
    oldItemId?: string;
    description: string;
    /** item_name on the NEW service's extra — names the gateway line (the old link's data.item is the booked room's). */
    newItemName?: string;
    oldCost: number;
    newCost: number;
    diff: number;
    originalData: any;
  }[] = [];
  // A single new extra-item link to POST as part of the reschedule (advance- or
  // short-notice reschedule fee). Lives outside reschedulePriceComparison
  // because it's a brand-new link, not a change to an existing one.
  public rescheduleAdditionalFee: {
    item_id: string;
    description: string;
    cost: number;
    data: any;
    // Present when part of the fee is covered by re-attributed overpaid
    // credit: the gateway charges chargedCost (cost − foldedAmount) and the
    // fee link is still created at full cost, fully paid.
    chargedCost?: number;
    foldedAmount?: number;
  } | null = null;

  // Total the reschedule payment actually charges. Reflects the customer's
  // payment choice below: the booking's outstanding balance (with the new
  // fees applied) + the reschedule fee when settling in full, or just the
  // new charges + the fee otherwise. Distinct from reschedulePriceDifference,
  // which remains the pure cost change used to update booking.price.
  public rescheduleTotalCharge = 0;

  // How the customer wants to pay when the booking carries an outstanding
  // balance: settle everything ('full') or only the new charges ('new').
  // Null until chosen; only asked when the two totals differ.
  public reschedulePaymentChoice: 'full' | 'new' | 'defer' | null = null;

  public setCurrentPage(page:string) {
    console.log(`page changed: ${page}`);
    this.pageChanged.next(page);
  }
  
  public primary_btn_text_colour:string = "white"
  public primary_btn_back_colour:string = "#00703c"
  public primary_btn_back_colour_hover:string = "#005a30"
  public primary_btn_text_colour_hover:string = "white"
  
  public secondary_btn_text_colour:string = "black"
  public secondary_btn_back_colour:string = "#f3f2f1"
  public secondary_btn_back_colour_hover:string = "#dbdad9"
  public secondary_btn_text_colour_hover:string = "black"

  // changes need to be made on access page instance too
  public bookingDetails: any = {
    serviceId: "",
    childCompanyId: "",
    parentCompanyId: "",
    resourceId: "",
    resourceName: "",
    event_id: "",
    duration: "",
    time: "",
    date: "",
    addon: "",
    find: "",
    duartion: "",
    res:"",
    bookingId:""
  }

  timer = false;

  lastPage= "/services"
}
